import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/internal/operators/catchError';

/**
 * Uses cookie-based auth for DASH API requests by always enabling
 * withCredentials so HttpOnly auth cookies are sent.
 */
export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Enable credentials only for requests going to our own API
  const apiBaseUrl = environment.dashApiUrl?.trim();
  const isApiRequest = apiBaseUrl
    ? req.url.startsWith(apiBaseUrl)
    : req.url.startsWith('/api');
  const outbound = isApiRequest
    ? next(req.clone({ withCredentials: true }))
    : next(req);

  return outbound.pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        //console.log('401 STATUS CODE: REDIRECT TO LOGIN')
        authService.clearAuth();
        router.navigate(['/login'], { queryParams: { err: 'Your session has expired. Please sign in again.' } });
      }
      return throwError(() => error);
    })
  )
};
